var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "264px",
    height: "280px",
    viewBox: "0 0 264 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with getavataaars.com")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "react-path-1",
    cx: 120,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,160 C12,226.27417 65.72583,280 132,280 C198.27417,280 252,226.27417 252,160 L264,160 L264,-1.42108547e-14 L-3.19744231e-14,-1.42108547e-14 L-3.19744231e-14,160 L12,160 Z",
    id: "react-path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,144.610951 L124,163 L128,163 L128,163 C167.764502,163 200,195.235498 200,235 L200,244 L0,244 L0,235 C-4.86974701e-15,195.235498 32.235498,163 72,163 L72,163 L76,163 L76,144.610951 C58.7626345,136.422372 46.3722246,119.687011 44.3051388,99.8812385 C38.4803105,99.0577866 34,94.0521096 34,88 L34,74 C34,68.0540074 38.3245733,63.1180731 44,62.1659169 L44,56 L44,56 C44,25.072054 69.072054,5.68137151e-15 100,0 L100,0 L100,0 C130.927946,-5.68137151e-15 156,25.072054 156,56 L156,62.1659169 C161.675427,63.1180731 166,68.0540074 166,74 L166,88 C166,94.0521096 161.51969,99.0577866 155.694861,99.8812385 C153.627775,119.687011 141.237365,136.422372 124,144.610951 Z",
    id: "react-path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-825.000000, -1100.000000)",
    id: "Avataaar/Circle"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(825.000000, 1100.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Circle",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(12.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Circle-Background",
    fill: "#E6E6E6",
    xlinkHref: "#react-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Blue-01",
    mask: "url(#react-mask-4)",
    fill: "#65C9FF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 240,
    height: 240
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Avataaar",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#react-mask-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(32.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-3"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D0C6AC",
    xlinkHref: "#react-path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFD-03-Brown",
    mask: "url(#react-mask-6)",
    fill: "#EDB98A"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M156,79 L156,102 C156,132.927946 130.927946,158 100,158 C69.072054,158 44,132.927946 44,102 L44,79 L44,94 C44,124.927946 69.072054,150 100,150 C130.927946,150 156,124.927946 156,94 L156,79 Z",
    id: "Neck-Shadow",
    fillOpacity: 0.100000001,
    fill: "#000000",
    mask: "url(#react-mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clothing/Shirt-Crew-Neck",
    transform: "translate(0.000000, 170.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M165.960472,29.2949161 C202.936473,32.3249982 232,63.2942856 232,101.051724 L232,110 L32,110 L32,101.051724 C32,62.9525631 61.591985,31.7649812 99.0454063,29.2195264 C99.0152598,29.5931145 99,29.9692272 99,30.3476251 C99,42.2107177 113.998461,51.8276544 132.5,51.8276544 C151.001539,51.8276544 166,42.2107177 166,30.3476251 C166,29.9946691 165.986723,29.6437014 165.960472,29.2949161 Z",
    id: "react-path-353"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-354",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-353"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Clothes",
    fill: "#E6E6E6",
    fillRule: "evenodd",
    xlinkHref: "#react-path-353"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Gray-01",
    mask: "url(#react-mask-354)",
    fillRule: "evenodd",
    fill: "#25557C"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uD83D\\uDD8DColor",
    x: 0,
    y: 0,
    width: 264,
    height: 110
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadowy",
    opacity: 0.599999964,
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#react-mask-354)",
    fillOpacity: 0.16,
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.000000, 4.000000)",
    id: "Hola-\\uD83D\\uDC4B\\uD83C\\uDFFC"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 27.8476251,
    rx: 39.6351047,
    ry: 26.9138272
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(76.000000, 82.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mouth/Smile",
    transform: "translate(2.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.117844,15.1280772 C36.1757121,24.6198025 44.2259873,32 54,32 C63.8042055,32 71.8740075,24.574136 72.8917593,15.0400546 C72.9736685,14.272746 72.1167429,13 71.042767,13 C56.1487536,13 44.7379213,13 37.0868244,13 C36.0066168,13 35.0120058,14.1784435 35.117844,15.1280772 Z",
    id: "react-path-371"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-372",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-371"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mouth",
    fillOpacity: 0.699999988,
    fill: "#000000",
    fillRule: "evenodd",
    xlinkHref: "#react-path-371"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Teeth",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#react-mask-372)",
    x: 39,
    y: 2,
    width: 31,
    height: 16,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tongue",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#react-mask-372)",
    fill: "#FF4F6D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 11,
    r: 11
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Nose/Default",
    transform: "translate(28.000000, 40.000000)",
    fillOpacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,12.418278 21.372583,16 28,16 L28,16 C34.627417,16 40,12.418278 40,8",
    id: "Nose"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyes/Default-\\uD83D\\uDE00",
    transform: "translate(0.000000, 8.000000)",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Eye",
    cx: 30,
    cy: 22,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Eye",
    cx: 82,
    cy: 22,
    r: 6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Eyebrow/Outline/Default",
    fillOpacity: 0.599999964
  }, /*#__PURE__*/React.createElement("g", {
    id: "I-Browse",
    transform: "translate(12.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63024536,11.1585767 C7.54515501,5.64986673 18.2779197,2.56083721 27.5230268,4.83118046 C28.5957248,5.0946055 29.6788665,4.43856013 29.9422916,3.36586212 C30.2057166,2.2931641 29.5496712,1.21002236 28.4769732,0.94659732 C17.7403633,-1.69001789 5.31209962,1.88699832 0.369754639,8.84142326 C-0.270109626,9.74178291 -0.0589363917,10.9903811 0.84142326,11.6302454 C1.74178291,12.2701096 2.9903811,12.0589364 3.63024536,11.1585767 Z",
    id: "Eyebrow",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6302454,11.1585767 C65.545155,5.64986673 76.2779197,2.56083721 85.5230268,4.83118046 C86.5957248,5.0946055 87.6788665,4.43856013 87.9422916,3.36586212 C88.2057166,2.2931641 87.5496712,1.21002236 86.4769732,0.94659732 C75.7403633,-1.69001789 63.3120996,1.88699832 58.3697546,8.84142326 C57.7298904,9.74178291 57.9410636,10.9903811 58.8414233,11.6302454 C59.7417829,12.2701096 60.9903811,12.0589364 61.6302454,11.1585767 Z",
    id: "Eyebrow",
    fillRule: "nonzero",
    transform: "translate(73.000154, 6.039198) scale(-1, 1) translate(-73.000154, -6.039198) "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Top",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "react-path-361",
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14998,39.9204083 C177.390206,37.1003988 174.185913,34.7068297 171.069252,32.3065503 C170.381566,31.777442 169.682843,31.2610833 169.010544,30.7118441 C168.857687,30.5870323 167.291999,29.4657388 167.104691,29.0530544 C166.653816,28.0602634 166.915042,28.8332916 166.977255,27.6485857 C167.055857,26.150508 170.11064,21.9193194 167.831176,20.9490079 C166.828413,20.522232 165.039628,21.6579526 164.077671,22.0330592 C162.196235,22.7671676 160.291721,23.3932399 158.346734,23.9330847 C159.278588,22.0763407 161.055333,18.3594977 157.71591,19.3543018 C155.114345,20.1293431 152.690052,22.1219709 150.075777,23.0594018 C150.940735,21.6415124 154.399901,17.2479341 151.274209,17.0023366 C150.301549,16.925839 147.471201,18.7503735 146.423952,19.1395717 C143.287223,20.3054888 140.083264,21.0590571 136.789999,21.6525844 C125.59203,23.6707114 112.497238,23.0953019 102.1368,28.1934632 C94.1494796,32.1236942 86.262502,38.2220278 81.648386,45.987539 C77.2011742,53.472559 75.537818,61.6641751 74.6069673,70.2412987 C73.9239644,76.535909 73.8684412,83.0425652 74.1878671,89.3599905 C74.2922241,91.4297869 74.5250203,100.970847 77.5319724,98.0813859 C79.0300967,96.641688 79.019059,90.8282073 79.3963495,88.8604076 C80.1472513,84.9452748 80.870057,81.0126951 82.122006,77.2227096 C84.3282191,70.5439339 86.9307879,63.4296587 92.4269209,58.8297383 C95.9539853,55.8782066 98.4307906,51.8889248 101.806002,48.9112229 C103.322188,47.5738572 102.165231,47.7130963 104.602902,47.888571 C106.240504,48.006337 107.885464,48.0512961 109.52641,48.0942421 C113.322394,48.1928837 117.124399,48.16772 120.921387,48.1811407 C128.56821,48.208653 136.179243,48.316689 143.818708,47.9164188 C147.213653,47.7385955 150.617965,47.6423024 154.00388,47.3282597 C155.895349,47.152785 159.251496,45.9405668 160.808488,46.8669256 C162.233362,47.7144383 163.71309,50.4817719 164.736257,51.615144 C167.153525,54.2935659 170.035717,56.3392052 172.862385,58.5354911 C178.756547,63.114945 181.732392,68.8666908 183.522515,76.023241 C185.305949,83.1532854 184.805905,89.76815 187.013456,96.78479 C187.401784,98.0184813 188.428965,100.14498 189.695296,98.2389151 C189.930434,97.8849461 189.869559,95.9390277 189.869559,94.819339 C189.869559,90.2995934 191.014141,86.9083772 190.999758,82.3591197 C190.943566,68.5271489 190.49637,50.4908308 180.14998,39.9204083 Z",
    id: "react-path-360"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.8%",
    y: "-2.0%",
    width: "101.5%",
    height: "108.0%",
    filterUnits: "objectBoundingBox",
    id: "react-filter-357"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0",
    type: "matrix",
    in: "shadowOffsetOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-359",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-361"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Top/Short-Hair/Short-Flat",
    mask: "url(#react-mask-359)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Facial-Hair/Beard-Light",
    transform: "translate(49.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.428403,98.1685688 C98.9148372,100.462621 96.23722,101.494309 92.8529444,100.772863 C92.2705777,100.648833 89.8963391,96.2345713 83.9998344,96.2345713 C78.1033297,96.2345713 75.7294253,100.648833 75.1467245,100.772863 C71.7624488,101.494309 69.0848316,100.462621 66.5712661,98.1685688 C61.8461772,93.855604 57.9166219,87.9081858 60.2778299,81.4191814 C61.5083844,78.0369425 63.5097479,74.3237342 67.1506257,73.2459109 C71.0384163,72.0955419 76.4968931,73.2439051 80.4147542,72.4582708 C81.6840664,72.2035248 83.0706538,71.7508657 83.9998344,71 C84.929015,71.7508657 86.3159365,72.2035248 87.5845805,72.4582708 C91.5027758,73.2439051 96.9612525,72.0955419 100.849043,73.2459109 C104.489921,74.3237342 106.491284,78.0369425 107.722173,81.4191814 C110.083381,87.9081858 106.153826,93.855604 101.428403,98.1685688 M140.081033,26 C136.670693,34.4002532 137.987774,44.8580348 137.356666,53.6758724 C136.844038,60.8431942 135.33712,71.5857526 128.972858,76.214531 C125.718361,78.5816138 119.79436,82.5598986 115.54187,81.4501943 C112.614539,80.6863848 112.302182,72.290096 108.455284,69.1469801 C104.09172,65.5823153 98.6429854,64.0160432 93.1491481,64.2578722 C90.7785381,64.3622683 85.9841367,64.3374908 83.9999331,66.1604584 C82.0157295,64.3374908 77.2216647,64.3622683 74.8510547,64.2578722 C69.3568808,64.0160432 63.9081467,65.5823153 59.5445817,69.1469801 C55.6976839,72.290096 55.3856641,80.6863848 52.4583326,81.4501943 C48.2058427,82.5598986 42.2818421,78.5816138 39.0270077,76.214531 C32.6624096,71.5857526 31.1561652,60.8431942 30.642864,53.6758724 C30.0120926,44.8580348 31.3291729,34.4002532 27.9188335,26 C26.2597768,26 27.3540339,42.1288693 27.3540339,42.1288693 L27.3540339,62.4851205 C27.3856735,77.7732046 36.935095,100.655445 58.1080116,109.393004 C63.2861266,111.52982 75.0153111,115 83.9999331,115 C92.9845551,115 104.71374,111.860188 109.891855,109.723371 C131.064771,100.985813 140.614193,77.7732046 140.646169,62.4851205 L140.646169,42.1288693 C140.646169,42.1288693 141.740089,26 140.081033,26",
    id: "react-path-363"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-362",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-363"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Lite-Beard",
    fill: "#331B0C",
    fillRule: "evenodd",
    xlinkHref: "#react-path-363"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Hair/Brown",
    mask: "url(#react-mask-362)",
    fill: "#4A312C"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32.000000, 0.000000)",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 264,
    height: 244
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "react-mask-358",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#react-path-360"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Short-Hair",
    stroke: "none",
    fill: "#1F3140",
    fillRule: "evenodd",
    xlinkHref: "#react-path-360"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Skin/\\uD83D\\uDC76\\uD83C\\uDFFD-03-Brown",
    mask: "url(#react-mask-358)",
    fill: "#4A312C"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 0.000000) ",
    id: "Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 264,
    height: 280
  }))))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar-2.1859fab5f65d2a41fed620abbb0170e5.svg";
export { ForwardRef as ReactComponent };